import { Tr, Td, Box } from '@chakra-ui/react'
import { FC, useEffect, useRef, useState } from 'react'

import useMrpScheduledPurschase from '@hook/mrp/use-scheduled-purchase'

interface IPuschaseProgramadaTr {
  id: number
  date: string
  dateDefault: string
  defaultQuantity: number
  entity: any
}

const ScheduledTr: FC<IPuschaseProgramadaTr> = ({
  id = 0,
  date = 'NaN',
  dateDefault = 'Nan',
  defaultQuantity = 0,
  entity
}) => {
  const [quantity, setQuantity] = useState(defaultQuantity)
  const editableRef = useRef<HTMLDivElement>(null)
  const { handleUpdateWanted } = useMrpScheduledPurschase()

  // Mantém a linha em sincronia com o valor aplicado pelo provider
  useEffect(() => {
    setQuantity(defaultQuantity)
  }, [defaultQuantity])

  // O campo é contentEditable: garante que o texto exibido seja o valor aplicado
  const syncEditable = (value: number) => {
    if (editableRef.current) {
      editableRef.current.textContent = String(value)
    }
  }

  const handleUpdateEntity = async (newQuantity: number) => {
    // Blur sem mudança (ou logo após o Enter) não soma a quantidade de novo
    if (Number.isNaN(newQuantity) || newQuantity === quantity) {
      syncEditable(quantity)
      return
    }

    const newCost =
      newQuantity *
      entity.estoque.custoUnitario *
      entity.estoque.produtoFornecedor.unidadeFornecedor.fatorConversao

    const updatedItem = {
      ...entity,
      desejada: {
        ...entity.desejada,
        quantidade: newQuantity,
        custo: newCost
      }
    }

    // O provider arredonda ao pacote: exibe o valor efetivamente aplicado
    const applied = await handleUpdateWanted(
      updatedItem,
      newQuantity,
      newCost,
      dateDefault
    )
    const finalQuantity = applied === undefined ? quantity : applied
    setQuantity(finalQuantity)
    syncEditable(finalQuantity)
  }

  return (
    <Tr>
      <Td width={5}>{id}</Td>
      <Td isNumeric>{date}</Td>
      <Td background="yellow.100">
        <Box
          ref={editableRef}
          border={2}
          borderColor="red"
          contentEditable
          suppressContentEditableWarning
          onBlurCapture={(e: { currentTarget: { textContent: any } }) =>
            handleUpdateEntity(Number(e.currentTarget.textContent))
          }
          onKeyDown={(e: {
            keyCode: number
            key: string
            preventDefault: () => void
            currentTarget: { textContent: any; blur: () => void }
          }) => {
            if (
              e.keyCode === 46 ||
              e.keyCode === 8 ||
              (e.keyCode > 95 && e.keyCode < 106) ||
              e.keyCode === 37 ||
              e.keyCode === 39
            ) {
              // let it happen, don't do anything
            } else {
              // Ensure that it is a number and stop the keypress
              if (e.keyCode < 48 || e.keyCode > 57) {
                e.preventDefault()
              }
            }
            if (e.key === '-') {
              e.preventDefault()
            }
            if (e.key === 'Enter') {
              e.preventDefault()
              // O blur dispara a atualização uma única vez
              e.currentTarget.blur()
            }
          }}
          css={{
            paddingLeft: 12
          }}
        >
          {quantity}
        </Box>
      </Td>
      <Td isNumeric>
        R${' '}
        {(
          quantity *
          entity.estoque.custoUnitario *
          entity.estoque.produtoFornecedor.unidadeFornecedor.fatorConversao
        ).toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}
      </Td>
    </Tr>
  )
}

export default ScheduledTr
